import React from 'react';
import localStorage from '../utils/localStorage';
import { notification, Button } from 'antd';

export function jwtToken(errorMessage) {
  const key = `open${Date.now()}`;
  const close = () => {
    localStorage.clear();
    // notification.close(key);
    window.location.reload();
  };
  const btn = (
    <Button type="primary"  onClick={close}>
      Log Out
    </Button>
  );
  notification['success']({
    message: errorMessage,
    btn,
    key,
    duration: 0
  });
}
